var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#E7EDF4"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.39 32h-2.058L8 8h4.797l2.316 15.188L17.992 8h4.033l2.884 15.172L27.219 8H32l-4.299 24h-4.863l-2.83-14.291L17.162 32H14.39z",
  fill: "#3A1E44"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNFN0VERjQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4zOSAzMkgxMi4zMzE5TDggOEgxMi43OTY3TDE1LjExMzQgMjMuMTg4MUwxNy45OTE3IDhIMTkuNDg1NUgyMC41NDc4SDIyLjAyNDlMMjQuOTA4NiAyMy4xNzIzTDI3LjIxOTkgOEgzMkwyNy43MDEzIDMySDI1LjYxSDI0LjYzMDdIMjIuODM4MkwyMC4wMDc5IDE3LjcwODlMMTcuMTYxOSAzMkgxNS4zODU5SDE0LjM5WiIgZmlsbD0iIzNBMUU0NCIvPgo8L3N2Zz4K";
export { SvgWhiteRounded as ReactComponent };